






























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Menu extends Vue {
    @Prop({ default: 'bug_report' }) icon: string;
    @Prop({ default: 'Menu' }) menu: string;
    @Prop({ default: '' }) route: string;
    @Prop({ default: 'lorem ipsum dolor si amet, consecteur elit, sed do eiusmod tempor incididunt ut labore et' })
    text: string;

    handleRoute() {
        this.$router.push({ name: this.route });
    }
}
